import {get} from '@/lib/request'

function categoryIndexPath() {
  return `/wp/v2/categories`
}

export function listCategories() {
  return get(categoryIndexPath())
}
